import React from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import Linkify from 'react-linkify';
import Avatar from '../../common/Avatar';
import UrlsList from '../UrlsList';

const renderProjects = (projects) =>
  projects.map(({ project }) => (
    <div key={project._id} className="c-user__project">
      <h5 className="u-margin-bottom-micro c-user__title">
        <Link
          to={`/projects/${project._id}`}
          className="c-box-primary__link u-color-blue-violet"
        >
          {`[${project.name}]`}
        </Link>
      </h5>
      <p className="c-user__text u-margin-bottom-none">
        <Linkify
          properties={{
            target: '_blank',
            className: 'u-color-blue-violet',
          }}
        >
          {project.description}
        </Linkify>
      </p>
    </div>
  ));

const renderSideProjects = (projects) =>
  projects.map(({ project }) => (
    <div key={project._id} className="c-user__project">
      <h5 className="u-margin-bottom-micro c-user__title">
        <Link
          to={`/projects/${project._id}`}
          className="c-box-primary__link u-color-shakespeare"
        >
          {`{${project.name}}`}
        </Link>
      </h5>
      <p className="c-user__text u-margin-bottom-none">
        <Linkify
          properties={{
            target: '_blank',
            className: 'u-color-blue-violet',
          }}
        >
          {project.description}
        </Linkify>
      </p>
    </div>
  ));

const Item = ({ user, t }) => (
  <div className="o-layout__item u-1/2@mini-geri u-1/1 u-margin-bottom">
    <div className="c-box c-user u-display-flex u-flex-column">
      <div className="c-user__info">
        <div className="o-media">
          <Link to={`/users/${user._id}`}>
            <Avatar
              className="o-media__img"
              width="55"
              height="55"
              src={user.getSmallAvatarUrl()}
              alt={user.user}
            />
          </Link>
          <div className="o-media__body">
            <h4 className="c-user__name u-margin-bottom-micro">
              <Link to={`/users/${user._id}`}>{user.name}</Link>
            </h4>
            <UrlsList urls={user.urls} />
          </div>
        </div>
      </div>

      {renderProjects(
        user.projects.filter(
          ({ status, project }) =>
            status === 'ACTIVE' && project.type === 'DEFAULT'
        )
      )}
      {renderSideProjects(
        user.projects.filter(
          ({ status, project }) =>
            status === 'ACTIVE' && project.type === 'SIDE'
        )
      )}

      <div className="u-text-center">
        <Link
          className="c-btn c-btn-simple c-btn-simple--secondary c-btn--effect u-padding-vertical-tiny u-display-block u-text-center"
          to={`/users/${user._id}`}
        >
          {t('user.viewProfile')}
        </Link>
      </div>
    </div>
  </div>
);

export default translate()(Item);



// WEBPACK FOOTER //
// ./src/user/users/Item.js